import React, { useEffect, useState } from "react";
import api from "./api"; // your axios instance
import DashboardLayout from "./layout/DashboardLayout";

function Dashboard() {
  const [message, setMessage] = useState("");

  useEffect(() => {
    api.get("/hello").then((res) => {
      setMessage(res.data.message);
    });
  }, []);

  return (
    <DashboardLayout>
      <h1>Welcome to shiv trade link Dashboard</h1>
          </DashboardLayout>
  );
}

export default Dashboard;
